export default __webpack_public_path__ + "static/media/4FDD49E4-6AC5-43C2-9552-1A5958351D1F_1_105_c.c24fd5ca.jpeg";